<template>
  <li :class="getType" v-if="!ocultarItem">
    <template v-if="router && router.name">
      <router-link :to="router">
        <i :class="icon"></i> <span>{{ name }}</span>
        <span class="pull-right-container" v-show="badge">
          <small class="label pull-right" :class="[badge.type === 'String' ? 'bg-green' : 'label-primary']">{{ badge.data }}</small>
        </span>
      </router-link>
    </template>
    <template v-else>
      {{ isHeader ? name : '' }}
      <a href="#" v-if="!isHeader">
        <i :class="icon"></i> <span>{{ name }}</span>
        <span class="pull-right-container">
          <small v-if="badge && badge.data" class="label pull-right" :class="[badge.type === 'String' ? 'bg-green' : 'label-primary']">{{ badge.data }}</small>
          <i v-else class="fa fa-angle-left pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu" v-if="filterItems.length > 0">
        <router-link tag="li" v-for="(item, index) in filterItems" :data="item" :key="index" :to="item.router" v-if="item.router && item.router.name">
          <a v-if="exibeSubMenuGrupoUsuario(item)">
            <i :class="item.icon"></i> {{ item.name }}
          </a>
        </router-link>
      </ul>
    </template>
  </li>
</template>

<script>
export default {
  name: 'va-slide-item',
  props: {
    type: {
      type: String,
      default: 'item'
    },
    isHeader: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String
    },
    badge: {
      type: Object,
      default() {
        return {}
      }
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    router: {
      type: Object,
      default() {
        return {
          name: ''
        }
      }
    },
    link: {
      type: String,
      default: ''
    }
  },
  created() {

  },
  computed: {
    getType() {
      if (this.isHeader) {
        return 'header'
      }
      return this.type === 'item' ? '' : 'treeview'
    },
    filterItems() {
      return this.items.filter((i) => {
        // condição para verificar se o usuario pode acessar o Ajustes de Base Unica
        if (i.router.name == 'Ajustes') {
          return this.verificarPermissao()
        }
        // esconder itens de Simulação Preventivas para quem não é o usuário autorizado
        if (i.router && ['SimulacaoGeral', 'ImportarPreventivas'].includes(i.router.name)) {
          return this.isFabricio()
        }
        return i.router && i.router.name
      })
    },
    ocultarItem() {
      // Esconde a árvore "Simulação Preventivas" para não autorizados
      return (this.type === 'tree' && this.name === 'Simulação Preventivas' && !this.isFabricio())
    }
  },
  methods: {
    changeTree(obj) {
      let found = null
      document.querySelectorAll('[class*=root-tree]').forEach((element, index) => {
        if ((element.textContent.trim() !== obj.trim())) {
          for (const a of document.querySelectorAll('.treeview')) {
            if (a.textContent.includes(element.textContent.trim())) {
              found = a
              break
            }
          }
          if (found.classList.contains('menu-open')) {
            found.classList.remove('menu-open')
            found.childNodes[3].style.display = 'none'
          }
        }
      })
    },
    comparaArrays: (a, b) => {
      for (let j = 0; j < b.length; j++) {
        return true
      }
      return false
    },
    exibeSubMenuGrupoUsuario: function (subMenu) {
      let usuarioGrupo = this.$store.state.login.loginUsuario.grupo
      console.log('subMenu', subMenu)
      /* if (usuarioGrupo.nome !== 'oi' && usuarioGrupo.nome !== 'VTAL' && usuarioGrupo.nome !== 'adminVTAL' && usuarioGrupo.nome !== 'admin' && subMenu === 'Abrir chamados por CSV') {
        return false
      } else {
        if (subMenu === 'Extracontratual' && usuarioGrupo.nome !== 'oi') {
          return false
        }
        return true
      } */
      // console.warn('>', subMenu.name)
      // checa se o usuário possui um grupo que pode acessar a aba
      // do menu. As permissões estão em lib/slideMenuItems
      let [g1, g2, g3] = usuarioGrupo

      console.log('Gs', g1, g2, g3)
      if (subMenu.grupos === undefined) {
        return true
      }
      if (g2 === undefined) {
        return subMenu.grupos.includes(g1.nome)
      }

      if (g3 === undefined) {
        return subMenu.grupos.includes(g1.nome) || subMenu.grupos.includes(g2.nome)
      }
      // console.log(subMenu.grupos.includes(g1.nome))
      return subMenu.grupos.includes(g1.nome) || subMenu.grupos.includes(g2.nome) || subMenu.grupos.includes(g3.nome)
    },
    // função para verificar se usuario está entre os permitidos para acesso a rota
    verificarPermissao: function () {
      const emailsPermitidos = [
        'fabricio.elias@portalssp.com',
        'fabricio.alves@portalssp.com',
        'filipe.husak@portalssp.com',
        'ssp@portalssp.com',
        'suporte@portalssp.com',
        'leila.gomes@portalssp.com',
        'caroline.maciel@oi.net.br',
        'luciano.carvalho@oi.net.br',
      ]
      let emailUser = this.$store.state.login.loginUsuario.usuario.email.toLowerCase()
      if (emailsPermitidos.indexOf(emailUser) === -1) {
        return false
      } else {
        return true
      }
    },
    isFabricio: function () {
      try {
        const email = (this.$store.state.login.loginUsuario.usuario.email || '').toLowerCase()
        return email === 'fabricio.elias@portalssp.com'
      } catch (e) {
        return false
      }
    }
  }

}
</script>



// WEBPACK FOOTER //
// VASlideItem.vue?b5ad2cf8